import * as AT from './actionTypes'

export const setSnackbar=(isShow,typeMsg,msg)=>{

    return{
        type:AT.SET_SNACKBAR,
        isShow,
        typeMsg,
        msg
}

}